import {ANALYTICS_COOKIES} from "./constants";
import {USER_METRICS_COOKIES} from "./constants";
import {getCookieValue} from "./utilityFunctions";

export {};

function getCookie(name: string): string | null {
    const value = getCookieValue(name);
    return value ? decodeURIComponent(value) : null;
}

(() => {
    // Store possible UTM params in a session cookie
    const urlParams = new URLSearchParams(location.search);
    const utmValues = {} as Record<string, string>;
    const utmDataLayer = {} as Record<string, string>;

    for (const key of urlParams.keys()) {
        if (key.startsWith('utm_')) {
            utmValues[key] = urlParams.get(key) ?? '';
            utmDataLayer[key.replace('utm_', '')] = urlParams.get(key) ?? '';
        }
    }

    const existingAnalyticsCookie = getCookie(ANALYTICS_COOKIES);
    const dataToStore = existingAnalyticsCookie ? JSON.parse(existingAnalyticsCookie) : {};
    for (const key in utmValues) {
        dataToStore[key] = utmValues[key];
    }
    
    document.cookie = `${ANALYTICS_COOKIES}=${encodeURIComponent(JSON.stringify(dataToStore))};path=/; SameSite=Lax; Secure`;

    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
        event: 'utm_loaded',
        utm: utmDataLayer,
    });
})();

export default function initUserMetrics() {
    const setCookie = (name: string, value: object) => {
        document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))};path=/;SameSite=Lax;Secure`;
    };

    const existing = getCookie(USER_METRICS_COOKIES);
    let metrics = existing
        ? JSON.parse(existing)
        : {
            visit_count: 0,
            last_session: new Date().toISOString(),
            patient_page_count: 0,
            provider_page_count: 0,
            video_clicks: 0,
            faq_clicks: 0,
            provider_domain: { count: 0, last: null },
            my_domain: { count: 0, last: null },
            utm_params: {},
        };

    // Store UTM params in a session cookie
    const urlParams = new URLSearchParams(location.search);
    if(typeof metrics.utm_params === 'undefined') {
        metrics.utm_params = {};
    }

    for (const key of urlParams.keys()) {
        if (key.startsWith('utm_')) {
            metrics.utm_params[key] = urlParams.get(key) ?? '';
        }
    }

    metrics.visit_count += 1;
    metrics.last_session = new Date().toISOString();

    const path = location.pathname.toLowerCase();
    if (path.includes("patient")) metrics.patient_page_count += 1;
    if (path.includes("hcp") || path.includes("provider")) metrics.provider_page_count += 1;

    document.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;

        // 🎥 Video play button
        if (target.closest(".btn-play-video")) {
            metrics.video_clicks += 1;
        }

        const link = target.closest("a") as HTMLAnchorElement;
        if (link && link.href) {
            try {
                const url = new URL(link.href, location.origin);
                const now = new Date().toISOString();

                if (url.pathname.match(/\/faqs\/?$/i)) {
                    metrics.faq_clicks += 1;
                }

                if (url.hostname.includes("provider.grail.com")) {
                    metrics.provider_domain.count += 1;
                    metrics.provider_domain.last = now;
                }

                if (url.hostname.includes("my.grail.com")) {
                    metrics.my_domain.count += 1;
                    metrics.my_domain.last = now;
                }
            } catch {
            }
        }

        setCookie(USER_METRICS_COOKIES, metrics);
    });

    setCookie(USER_METRICS_COOKIES, metrics);
}